var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-organization py-5"},[_vm._l((_vm.rows),function(row){return _c('input-organization',{key:row.id,attrs:{"value":row.name,"id":row.id,"tagId":_vm.tagId}})}),_c('create-organization',{attrs:{"tagId":_vm.tagId,"organizations":_vm.rows}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }